export function getDigitFromId(id: string) {
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return Math.floor((parseInt(id.at(-1)!, 16) * 10) / 16);
}
